import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { CustomTooltip } from "../../../../../../styles/TooltipStyles";
import useLabels from "../../../../../../customHooks/useLabels";
import { TOOLTIP_COLORS } from "../../../../../../styles/Variables";
import Information from "../../../../../../images/Info.svg";
import JunctionImage from "../../../../../../images/ItemIcons/Junction.svg";
import Camera from "../../../../../../images/ItemIcons/camera.svg";
import Signal from "../../../../../../images/ItemIcons/signals.svg";

import { Button } from "../../../../../../stories/Button/Button";
import Input from "../../../../../../stories/Input/Input";
import Legends from "./Legends";
import {
  CustomDrawer,
  JunctionDetailsDrawer,
} from "../../../../../../styles/CustomDrawerStyles";
import ViewAssetDetails from "../raisedtickets/ViewAssetDetails";
import JunctionDetails from "./JunctionDetails";
import { TableType } from "../../../../customer/companies/queries/types";
import {
  GetCompanyIdByJunctionNode,
  GetDataForMaps,
} from "../../../masters/items/queries/queries";
import {
  GetDataForMapsData,
  GetDataForMapsVars,
} from "../../../masters/items/queries/types";
import { useLazyQuery } from "@apollo/client";

import { nodeVar } from "../../../../../../utils/commonQueryTypes";
import { Junction } from "../../../masters/subsidary/junctions/queries/types";
import { MapsContext } from "../../context/context";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { TicketStatus } from "../../../../../../utils/constants";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const ViewJunctionDetails = ({ setModalFlag }: Props) => {
  const { itemLabel, junctionLabel } = useLabels();
  const [assetDetailsModal, setAssetDetailsModal] = useState(false);
  const { state } = useContext(MapsContext);

  const [GetCompanyByJunction, { data }] = useLazyQuery<
    { node: Junction },
    nodeVar
  >(GetCompanyIdByJunctionNode);

  const { customer_id } = useUrlParams();

  const [assetDetailsId, setAssetDetailsId] = useState(0);
  const { user_details } = useLoggedInUserDetails();

  const [GetAssetMaps, { data: ticketsData, loading }] = useLazyQuery<
    GetDataForMapsData,
    GetDataForMapsVars
  >(GetDataForMaps, {
    pollInterval: 20000,
  });

  useEffect(() => {
    GetCompanyByJunction({
      variables: {
        id: state.assetTypeId,
      },
    });
  }, [GetCompanyByJunction, state.assetTypeId]);

  useEffect(() => {
    if (customer_id) {
      GetAssetMaps({
        variables: {
          customerID: customer_id ? customer_id : 0,

          input: {
            id: state.assetTypeId
              ? state.assetTypeId
              : state.junctionId
              ? state.junctionId
              : 0,
            idType: TableType.JUNCTION,
            retTableType: TableType.ASSET,
            ticketStatus: [],
            empID: user_details.id,
            jType: [],
            LdgrIds: [],
            priority: [],
            itemID: 0,
          },
        },
      });
    }
  }, [
    customer_id,
    GetAssetMaps,
    state.company,
    state.subsidary,
    user_details.id,
    state.junctionId,
  ]);

  return (
    <>
      <div className="junction-details">
        <div className="junction-details__title">
          <Title>{junctionLabel} Details</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="junction-details__block">
          <JunctionDetails assetType={TableType.JUNCTION} />

          <div className="junction-details__block--total">
            <div>
              Total&nbsp;<span>{itemLabel}</span>
            </div>
            <b>{ticketsData ? ticketsData.GetDataForMaps.length : 0}</b>
          </div>
          {/* <Input id="data_search" placeholder="Search..." /> */}
          <div className="junction-details__block--ul">
            <ul>
              {ticketsData
                ? ticketsData.GetDataForMaps.map((res, index) => {
                    let img = require(`../../../../../../images/ItemIcons/${
                      res.icon ? res.icon : "item"
                    }.svg`);

                    return (
                      <li className="junction-details__block--li" key={index}>
                        <div className="junction-details__block--li--flex">
                          <img
                            className="junction-details__block--li--image"
                            src={img}
                            alt=""
                          />
                          <div className="junction-details__block--li--details">
                            <b
                              className={
                                res.ticketStatus === TicketStatus.OPEN
                                  ? "font-red"
                                  : "font-blue"
                              }
                            >
                              {res.name}
                            </b>
                            <b>{res.prodSerialNo}</b>
                            <span>
                              {res.latitude} {res.longitude}
                            </span>
                          </div>
                        </div>
                        <img
                          src={Information}
                          alt=""
                          onClick={() => {
                            setAssetDetailsId(res.id);
                            setAssetDetailsModal(!assetDetailsModal);
                          }}
                        />
                      </li>
                    );
                  })
                : null}
            </ul>
          </div>
        </div>
        <div className="junction-details__button">
          <Button mode="cancel" onClick={() => setModalFlag(false)} />
          <Legends />
        </div>
      </div>
      <JunctionDetailsDrawer
        anchor="right"
        open={assetDetailsModal}
        onClose={() => setAssetDetailsModal(!assetDetailsModal)}
      >
        <ViewAssetDetails
          setModalFlag={setAssetDetailsModal}
          itemId={assetDetailsId}
        />
      </JunctionDetailsDrawer>
    </>
  );
};

export default ViewJunctionDetails;
